export default __webpack_public_path__ + "static/media/section-process-bg2.03443f37.png";